menu:
  labels:
    label:
      show: Hiển thị
      adjust_sizes: Chỉnh sửa kích thước
      recommended_size: Khuyến khích (430x600)
      full_height: Toàn cửa sổ
      half_height: Nửa chiều cao
      full_screen: Toàn màn hình
      align_to: Căn chỉnh theo
      center: Giữa
      top_left: Góc trên phía trái
      top_right: Góc trên phía phải
      bottom_left: Góc dưới phía trái
      bottom_right: Góc dưới phía phải
      settings: Cài đặt...
      about: Giới thiệu...
      open_inlay: Mở khảm...
      open_widgets: Mở tiện ích...
      open_caption: Mở phụ đề...
      close_caption: Close Caption...
      caption_overlay: Lớp phủ phụ đề
      follow_window: Theo cửa sổ
      reset_position: Đặt lại vị trí
      devtools: Công cụ phát triển
      troubleshoot_beatsync: Sửa lỗi BeatSync...
      quit: Thoát ra
